import React from 'react';
import Advert from './Advert';


export default class Homepage extends React.Component {

  render () {
    let {title, languages} = this.props;

    let items = languages.map(({code, name}) => {
      return (
        <li key={code} className={code} onClick={() => this.onSelectLanguage(code)}>
          { name }
        </li>
      );
    });

    let advert = null;
    if (this.props.advert) {
      advert = (
        <Advert
          advert={this.props.advert}
          onClick={this.props.onAdvertClick}
          loop={true} />
      )
    }

    return (
      <div className="Homepage">
        <h1><small>INFO</small><br/>{ title }</h1>
        <ul className="languages">
          { items }
        </ul>
        { advert }
        <img className="hand" src={require('./img/hand.png')} />
      </div>
    );
  }

  onSelectLanguage(code) {
    this.props.onSelectLanguage(code);
    window.TRACKING_EVENT.event = 'language';
    window.TRACKING_EVENT.language = code;
    window.TRACKING_EVENT.source = 'home';
  }
}

